import { useSaleControllerProvider } from "./hooks";

interface WithSaleControllerProps {
  primaryColor: string;
}

export function withSaleController<
  T extends WithSaleControllerProps = WithSaleControllerProps
>(WrappedComponent: React.ComponentType<T>) {
  // Try to create a nice displayName for React Dev Tools.
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || "Component";

  // Creating the inner component. The calculated Props type here is the where the magic happens.
  const ComponentWithTheme = (
    props: Omit<T, keyof WithSaleControllerProps>
  ) => {
    // Fetch the props you want to inject. This could be done with context instead.
    const saleController = useSaleControllerProvider();

    // props comes afterwards so the can override the default ones.
    return <WrappedComponent {...saleController} {...(props as T)} />;
  };

  ComponentWithTheme.displayName = `withSaleController(${displayName})`;
  return ComponentWithTheme;
}
